const CurrencyUtil = {
    formatCurrency: (amount: number, currencyCode: string = 'USD'): string => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currencyCode,
        }).format(amount);
    }
};

export default CurrencyUtil;